
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Badge } from '@/components/ui/badge';
import { faqCategories } from '@/data/support/faqs';

interface FAQCategoryFilterProps {
  selectedCategory: string;
  selectedAudience: string;
  onCategoryChange: (category: string) => void;
  onAudienceChange: (audience: string) => void;
}

const audiences = [
  { id: 'older-adults', name: 'Older Adults' },
  { id: 'families', name: 'Families' },
  { id: 'caregivers', name: 'Caregivers' },
];

const FAQCategoryFilter = ({ 
  selectedCategory, 
  selectedAudience, 
  onCategoryChange, 
  onAudienceChange 
}: FAQCategoryFilterProps) => {
  return (
    <div className="flex flex-col md:flex-row gap-4 mb-8">
      <Select value={selectedCategory} onValueChange={onCategoryChange}>
        <SelectTrigger className="w-full md:w-64">
          <SelectValue placeholder="All Categories" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Categories</SelectItem>
          {faqCategories.map((category) => (
            <SelectItem key={category.id} value={category.id}>
              {category.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Select value={selectedAudience} onValueChange={onAudienceChange}>
        <SelectTrigger className="w-full md:w-64">
          <SelectValue placeholder="All Audiences" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Audiences</SelectItem>
          {audiences.map((audience) => (
            <SelectItem key={audience.id} value={audience.id}>
              {audience.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {(selectedCategory && selectedCategory !== 'all' || selectedAudience && selectedAudience !== 'all') && (
        <div className="flex items-center gap-2">
          {selectedCategory && selectedCategory !== 'all' && (
            <Badge variant="secondary" className="cursor-pointer" onClick={() => onCategoryChange('all')}>
              {faqCategories.find(c => c.id === selectedCategory)?.name} ✕
            </Badge>
          )}
          {selectedAudience && selectedAudience !== 'all' && (
            <Badge variant="secondary" className="cursor-pointer" onClick={() => onAudienceChange('all')}>
              {audiences.find(a => a.id === selectedAudience)?.name} ✕
            </Badge>
          )}
        </div>
      )}
    </div>
  );
};

export default FAQCategoryFilter;
